<template>
  <div>
    <div
      class="modal fade"
      id="surveyModal"
      ref="surveyModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="surveyModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content" v-if="loaded">
          <div class="modal-header">
            <h5 class="modal-title" id="surveyModalLabel"></h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="postpone"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3" v-html="snarkdown(survey.description)"></div>
            <div class="" v-for="question in survey.questions" :key="kebabCase(question.title)">
              <SurveyQuestion :question="question" :errors="errors" v-model="question.value"></SurveyQuestion>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" class="btn btn-link text-muted btn-sm" data-bs-dismiss="modal" @click="postpone">
              {{ 'Remind me later' | translate }}
            </button>
            <button type="button" class="btn btn-dark btn-sm px-3" @click="submit">{{ 'Submit' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { kebabCase } from 'lodash'
import snarkdown from 'snarkdown'
import SurveyQuestion from '~/web-components/survey/SurveyQuestion.vue'

export default {
  props: ['surveyId'],
  components: {
    SurveyQuestion,
  },
  data() {
    return {
      errors: [],
      loaded: false,
      settings: {
        lastDisplayedAt: localStorage.getItem(`survey_${this.surveyId}_last_displayed_at`),
      },
      modal: null,
      survey: null,
      responded_at: null,
    }
  },
  methods: {
    kebabCase,
    getSurveyData() {
      axios
        .post(`/survey/${this.surveyId}`)
        .then(({ data }) => {
          this.setRespondedAt(data.responded_at)
          this.survey = data.survey
          this.loaded = true
        })
        .then(() => {
          if (this.responded) {
            return false
          }
          this.modal.show()
        })
    },
    submit() {
      axios
        .post('/survey/submit', {
          survey_id: this.surveyId,
          response: this.responses(),
        })
        .then(({ data }) => {
          this.modal.hide()
          this.setRespondedAt(data.responded_at)
        })
        .catch((error) => {
          this.errors = _.get(error, 'response.data.errors', [])
        })
    },
    responses() {
      return _.merge(
        {},
        ...this.survey.questions.map((q) => {
          return { [this.kebabCase(q.title)]: q.value }
        }),
      )
    },
    snarkdown(text) {
      if (!text) {
        return ''
      }
      return snarkdown(text)
    },
    postpone() {
      localStorage.setItem(`survey_${this.surveyId}_last_displayed_at`, Date.now())
    },
    setRespondedAt(timestamp) {
      if (timestamp) {
        this.responded = true
        localStorage.setItem(`survey_${this.surveyId}_responded_at`, timestamp)
      }
    },
    respondedAt() {
      return (this.responded_at = localStorage.getItem(`survey_${this.surveyId}_responded_at`))
    },
    timeDiff() {
      return Date.now() - this.settings.lastDisplayedAt
    },
    surveyHasBeenRecentlyDisplayed() {
      if (!this.settings.lastDisplayedAt) {
        return false
      }
      const dayInMs = 24 * 60 * 60 * 1000
      return this.timeDiff() < dayInMs
    },
    msToHours(ms) {
      return Math.round(ms / (1000 * 60 * 60))
    },
  },
  mounted() {
    if (this.surveyId && !this.respondedAt() && !this.surveyHasBeenRecentlyDisplayed()) {
      this.modal = new bootstrap.Modal(this.$refs.surveyModal)
      this.getSurveyData()
    }
  },
}
</script>

<style></style>
